export default {
      id: "arrow-with-stem-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#arrow-with-stem",
      toString: function () {
        return this.url;
      }
    }